// @flow

const formatCompanyName = (companyAddress: ?string): string => {
  if (!companyAddress) {
    return '';
  }
  const companyName = companyAddress.split('\n')[0];
  return `(${companyName})`;
};

export default formatCompanyName;
